export type TaskCategoryId = 1 | 2 | 3 | 4 | 5;

export const TaskCategories = {
  WAIVER: 1 as TaskCategoryId,
  QUESTIONNAIRE: 2 as TaskCategoryId,
  UPLOAD_TASK: 3 as TaskCategoryId,
  PROFILE: 4 as TaskCategoryId,
  NAME_PRONUNCIATION: 5 as TaskCategoryId,
};

export const TaskTypes = {
  CONSENT_TO_RESELECT: 17,
};

export type TaskTypeDTO = {
  taskTypeId: number;
  taskTypeName: string;
  taskPriority: string;
};

export type TaskReopenRequestDTO = {
  prospectId: number;
  taskId: number;
  reopenReason: string;
};
